/**
 * icons.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

// Unicode icons for the application
export const Icons = {
  // Navigation
  home: '🏠',
  shop: '🛍️',
  about: 'ℹ️',
  contact: '📞',
  admin: '⚙️',
  cart: '🛍️',
  login: '🔐',
  register: '📝',
  logout: '🚪',
  
  // User actions
  user: '👤',
  edit: '✏️',
  delete: '🗑️',
  save: '💾',
  cancel: '❌',
  add: '➕',
  remove: '➖',
  search: '🔍',
  filter: '🔽',
  sort: '🔄',
  refresh: '🔄',
  upload: '📤',
  download: '📥',
  view: '👁️',
  hide: '🙈',
  show: '👁️',
  copy: '📋',
  tag: '🏷️',
  share: '📤',
  send: '📨',
  mail: '✉️',
  
  // Content types
  book: '📖',
  cd: '💿',
  music: '🎵',
  bundle: '📦',
  image: '🖼️',
  video: '🎥',
  audio: '🎧',
  document: '📄',
  pdf: '📋',
  
  // Status indicators
  success: '✅',
  error: '❌',
  warning: '⚠️',
  info: 'ℹ️',
  loading: '⏳',
  pending: '⏸️',
  active: '🟢',
  inactive: '🔴',
  online: '🟢',
  offline: '🔴',
  
  // Social media
  facebook: '📘',
  twitter: '🐦',
  instagram: '📷',
  youtube: '📺',
  email: '📧',
  phone: '📞',
  
  // E-commerce
  price: '💰',
  discount: '🏷️',
  shipping: '🚚',
  delivery: '📦',
  pickup: '🏪',
  payment: '💳',
  receipt: '🧾',
  invoice: '📋',
  
  // Music specific
  violin: '🎻',
  fiddle: '🎻',
  guitar: '🎸',
  piano: '🎹',
  drum: '🥁',
  microphone: '🎤',
  headphones: '🎧',
  speaker: '🔊',
  play: '▶️',
  pause: '⏸️',
  stop: '⏹️',
  next: '⏭️',
  previous: '⏮️',
  volume: '🔊',
  mute: '🔇',
  
  // File types
  folder: '📁',
  file: '📄',
  zip: '🗜️',
  article: '📄',
  
  // UI elements
  menu: '☰',
  close: '✕',
  back: '⬅️',
  arrowLeft: '⬅️',
  forward: '➡️',
  up: '⬆️',
  down: '⬇️',
  left: '⬅️',
  right: '➡️',
  expand: '⬇️',
  collapse: '➡️',
  settings: '⚙️',
  help: '❓',
  question: '❓',
  exclamation: '❗',
  
  // Weather and time
  sun: '☀️',
  moon: '🌙',
  star: '⭐',
  clock: '🕐',
  calendar: '📅',
  time: '⏰',
  
  // Miscellaneous
  heart: '❤️',
  like: '👍',
  dislike: '👎',
  thumbsUp: '👍',
  thumbsDown: '👎',
  fire: '🔥',
  diamond: '💎',
  trophy: '🏆',
  medal: '🏅',
  flag: '🏁',
  checkmark: '✓',
  cross: '✗',
  plus: '+',
  minus: '-',
  equals: '=',
  infinity: '∞',
  copyright: '©',
  trademark: '™',
  registered: '®',
  link: '🔗',
  eye: '👁️',
  archive: '📦'
};

// Helper function to get icon with fallback
export const getIcon = (iconName, fallback = '❓') => {
  return Icons[iconName] || fallback;
};

// Helper function to get icon with custom styling
export const getIconWithStyle = (iconName, className = '', fallback = '❓') => {
  const icon = getIcon(iconName, fallback);
  return <span className={`icon ${className}`}>{icon}</span>;
};

export default Icons;
